// Projects 页面相关的翻译资源
export const projectsResources = {
  zh: {
    // Projects page
    "projects.title": "项目进展",
    "projects.filter.all": "全部",
    "projects.filter.completed": "已完成",
    "projects.filter.inProgress": "进行中",
    "projects.filter.pending": "未开始",
    "projects.status.completed": "已完成",
    "projects.status.inProgress": "进行中",
    "projects.status.pending": "未开始",
    "projects.projectNumber": "项目序号",
    "projects.startDate": "开始时间",
    
    // Project Detail page
    "projectDetail.title": "项目详情",
    "projectDetail.notFound": "未找到该项目",
    "projectDetail.backToList": "返回项目列表",
    "projectDetail.applyLink": "点击查看申请资助",
  },
  zh_TW: {
    // Projects page
    "projects.title": "項目進展",
    "projects.filter.all": "全部",
    "projects.filter.completed": "已完成",
    "projects.filter.inProgress": "進行中",
    "projects.filter.pending": "未開始",
    "projects.status.completed": "已完成",
    "projects.status.inProgress": "進行中",
    "projects.status.pending": "未開始",
    "projects.projectNumber": "項目序號",
    "projects.startDate": "開始時間",
    
    // Project Detail page
    "projectDetail.title": "項目詳情",
    "projectDetail.notFound": "未找到該項目",
    "projectDetail.backToList": "返回項目列表",
    "projectDetail.applyLink": "點擊查看申請資助",
  },
  en: {
    // Projects page
    "projects.title": "Project Progress",
    "projects.filter.all": "All",
    "projects.filter.completed": "Completed",
    "projects.filter.inProgress": "In Progress",
    "projects.filter.pending": "Pending",
    "projects.status.completed": "Completed",
    "projects.status.inProgress": "In Progress",
    "projects.status.pending": "Pending",
    "projects.projectNumber": "Project No.",
    "projects.startDate": "Start Date",
    
    // Project Detail page
    "projectDetail.title": "Project Detail",
    "projectDetail.notFound": "Project not found",
    "projectDetail.backToList": "Back to Project List",
    "projectDetail.applyLink": "Click to view application for funding",
  }
};

